import { Grid, makeStyles, Theme, TextField, MenuItem } from "@material-ui/core";
import React, { FunctionComponent, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Gender } from "../../../api/smartmelts-api/graphql/generated";
import { DARK_TEXT_COLOR } from "../../../theme/theme";
import { OnboardingContext } from "../context/onboarding-context";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: theme.spacing(2),
  },
  detailWrapper: {
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(4),
    "& .MuiFormLabel-root": {
      color: DARK_TEXT_COLOR,
      fontWeight: 700,
    },
  },
  dateField: {
    "& input::-webkit-date-and-time-value": {
      // Ios fix
      textAlign: "left",
    },
  },
  dateLabel: {
    color: theme.palette.common.black,
    fontWeight: 700,
  },
}));

interface IOnboardingIntroductionProps {}

export const OnboardingInfo: FunctionComponent<IOnboardingIntroductionProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [changedDateOfBirth, setChangeDateOfBirth] = useState<boolean>(false);

  const {
    firstname,
    setFirstname,
    setGender,
    gender,
    setDateOfBirth,
    dateOfBirth,
    dateOfBirthDate,
    lastname,
    setLastname,
  } = useContext(OnboardingContext);

  return (
    <Grid container justify="space-between" className={classes.container}>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          fullWidth
          select
          label={t("onboarding.gender.label")}
          id="onboarding-gender-select"
          value={gender}
          onChange={(event) => setGender(event.target.value as Gender)}
          autoFocus
        >
          {Object.keys(Gender).map((key) => {
            return (
              <MenuItem value={key} key={key}>
                {t(`gender.${Gender[key]}`)}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          className={classes.dateField}
          fullWidth
          label={t("onboarding.date_of_birth.label")}
          id="onboarding-date-of-birth"
          type="date"
          value={dateOfBirth}
          onChange={(event) => {
            setChangeDateOfBirth(true);
            setDateOfBirth(event.target.value);
          }}
          error={changedDateOfBirth && !dateOfBirthDate.isValid}
          autoFocus
          InputLabelProps={{ shrink: true, className: classes.dateLabel }}
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          fullWidth
          label={t("onboarding.firstname.label")}
          value={firstname}
          onChange={(event) => setFirstname(event.target.value)}
          error={!firstname}
          autoFocus
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.detailWrapper}>
        <TextField
          fullWidth
          label={t("onboarding.lastname.label")}
          value={lastname}
          onChange={(event) => setLastname(event.target.value)}
          error={!lastname}
          autoFocus
        />
      </Grid>
    </Grid>
  );
};
